import { I18n } from "@assets/strings";
import React from "react";
import { RepostIcon } from "@ui/components/icons";
import { KebabMenu } from "@ui/components/menus/kebabMenu";
import { MenuRow } from "@ui/components/menus/menuRow";
import { IconWrapper, SimpleMenuContent } from "@ui/components/menus/simpleMenuContent";

interface LivecourseMenuProps extends React.HTMLAttributes<HTMLDivElement> {
	blur?: boolean;
}
export const LivecourseMenu: React.FC<LivecourseMenuProps> = ({ blur, ...htmlProps }) => {
	return (
		<KebabMenu blur={blur} closeOnSelect onClick={(e) => e.stopPropagation()} {...htmlProps} authOnly>
			<SimpleMenuContent>
				<MenuRow>
					<IconWrapper>
						<RepostIcon />
					</IconWrapper>
					<span>{I18n.t("share")}</span>
				</MenuRow>
			</SimpleMenuContent>
		</KebabMenu>
	);
};
